import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-body-wrapper" }
const _hoisted_2 = ["data-layout"]
const _hoisted_3 = { class: "page-body" }

import { useMenuStore } from "@/store/menu";
import { uselayoutStore } from "@/store/layout";
import { storeToRefs } from "pinia";
import { ref, defineAsyncComponent, watch, onMounted } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'bodyView',
  setup(__props) {

const Header = defineAsyncComponent(() => import("@/components/commen/block/header/headerSection.vue"))
const Sidebar = defineAsyncComponent(() => import("@/components/commen/block/sidebar/sidebarSection.vue"))
// const footerView = defineAsyncComponent(() => import("@/layout/footerView.vue"))
const tapTop = defineAsyncComponent(() => import("@/layout/tapTop.vue"))
const layoutobj = ref<any>({});
const sidebar_toggle_var = ref<boolean>(false);
const display = ref<boolean>(false)
const store = useMenuStore();
const storeLayout = uselayoutStore();
const { layout: layout } = storeToRefs(storeLayout);
watch(
    () => layout,
    () => {
        layoutobj.value = storeLayout.layout.settings.sidebar_setting;
    },
    { deep: true },
);
watch(
    () => "router",
    () => {

        if ((window.innerWidth < 991 && storeLayout.layout.settings.layout === 'Horizontal')) {
            const newlayout = JSON.parse(JSON.stringify(layoutobj).replace('horizontal-wrapper', 'compact-wrapper'));
            layoutobj.value = JSON.parse(JSON.stringify(newlayout))[storeLayout.layout.settings.layout];
        } else {
            layoutobj.value = JSON.parse(JSON.stringify(layoutobj))[storeLayout.layout.settings.layout];
        }
    }
)
function sidebar_toggle(value: boolean) {
    sidebar_toggle_var.value = !value;
}
function handleScroll() {
    if (window.innerWidth <= 1199) {
        display.value = true;
    } else {
        display.value = false;
    }
}
onMounted(() => {

    window.addEventListener('resize', handleScroll);
    layoutobj.value = storeLayout.layout.settings.sidebar_setting;
    // localStorage.setItem("cartItem", JSON.stringify(product.cart));
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_customizer = _resolveComponent("customizer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(tapTop)),
    _createElementVNode("div", {
      class: _normalizeClass(["page-wrapper", display.value ? 'compact-sidebar compact-small material-icon' : layoutobj.value]),
      id: "pageWrapper"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["page-header", { close_icon: !_unref(store).togglesidebar }])
      }, [
        _createVNode(_unref(Header), { onClicked: sidebar_toggle })
      ], 2),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["sidebar-wrapper", [{ close_icon: !_unref(store).togglesidebar, 'sidebar-default': _unref(store).perentName }]]),
          "data-layout": _unref(storeLayout).svg == 'stroke-svg' ? 'stroke-svg' : 'fill-svg'
        }, [
          _createVNode(_unref(Sidebar), { onClicked: sidebar_toggle })
        ], 10, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "container-fluid" }, null, -1)),
          _createVNode(_Transition, {
            name: "fadeIn",
            "enter-active-class": "animated fadeIn"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ])
      ])
    ], 2),
    _createVNode(_component_customizer)
  ], 64))
}
}

})